import { Component, HostListener, Input, OnInit } from '@angular/core';
import { Class } from '../../../data/class';
import { Student } from '../../../data/student';
import { BaseComponent } from '../../../base/base.component';
import { json2csv } from 'json-2-csv';
import { FileUtilities } from '../../../utilities/file-utilities';
import { DatepickerViewModel } from '@ng-bootstrap/ng-bootstrap/datepicker/datepicker-view-model';

@Component({
  selector: 'app-staff-accounts-report',
  templateUrl: './staff-accounts-report.component.html',
  styleUrls: ['./staff-accounts-report.component.scss']
})
export class StaffAccountsReportComponent extends BaseComponent implements OnInit {
  
  organizationID: number;
  running = false;

  getResult(): void {
    this.running = true;
    this.dataService.getStaffAccountsReport(this.organizationID).subscribe(json => {
      this.running = false;
      json2csv(json, (err, csv) => {
        FileUtilities.saveFile(csv, 'StaffAccountsReport_' + this.organizationID + '.csv', 'text/csv');
       });
    }); 
  }
}
